import { StepConfig } from '../types'

export const STEPS: StepConfig[] = [
  {
    id: 'role',
    question: 'What best describes your role?',
    fieldName: 'role',
    required: true,
    randomizeOptions: true,
    options: [
      { label: 'Business owner / Entrepreneur', value: 'Business owner / Entrepreneur' },
      { label: 'Manager / Team Lead', value: 'Manager / Team Lead' },
      { label: 'Individual contributor', value: 'Individual contributor' },
      { label: 'Consultant / Agency / Freelancer', value: 'Consultant / Agency / Freelancer' },
      { label: 'Developer / Engineer', value: 'Developer / Engineer' },
      { label: 'Student / Learner', value: 'Student / Learner' },
      { label: 'Other', value: 'Other' },
    ],
  },
  {
    id: 'useCase',
    question: 'What will you use Botpress for?',
    fieldName: 'useCase',
    required: true,
    randomizeOptions: true,
    options: [
      { label: 'Customer support chatbot', value: 'Customer support chatbot' },
      { label: 'Lead generation / qualification', value: 'Lead generation / qualification' },
      { label: 'E-commerce recommendations', value: 'E-commerce recommendations' },
      { label: 'Internal tools (HR, IT, helpdesk)', value: 'Internal tools (HR, IT, helpdesk)' },
      { label: 'Learning / education bot', value: 'Learning / education bot' },
      { label: 'Experimenting / learning AI', value: 'Experimenting / learning AI' },
      { label: 'Not sure', value: 'Not sure' },
      { label: 'Other', value: 'Other' },
    ],
  },
  {
    id: 'companySize',
    question: 'How many people work at your company?',
    fieldName: 'companySize',
    required: true,
    options: [
      { label: 'Just me', value: '1' },
      { label: '2-10', value: '2-10' },
      { label: '11-50', value: '11-50' },
      { label: '51-100', value: '51-100' },
      { label: '101-300', value: '101-300' },
      { label: '301-1,000', value: '301-1,000' },
      { label: '1,000+', value: '1,000+' },
    ],
  },
  {
    id: 'discoverySource',
    question: 'How did you hear about us?',
    fieldName: 'discoverySource',
    required: true,
    randomizeOptions: true,
    options: [
      { label: 'Colleague / Friend', value: 'Colleague / Friend' },
      { label: 'LinkedIn', value: 'LinkedIn' },
      { label: 'Podcast', value: 'Podcast' },
      { label: 'Reddit', value: 'Reddit' },
      { label: 'Other LLM (Meta AI, Perplexity, etc.)', value: 'Other LLM (Meta AI, Perplexity, etc.)' },
      { label: 'G2', value: 'G2' },
      { label: 'YouTube', value: 'YouTube' },
      { label: 'Webinar', value: 'Webinar' },
      { label: 'ChatGPT', value: 'ChatGPT' },
      { label: 'Google Search', value: 'Google Search' },
      { label: 'Teacher', value: 'Teacher' },
      { label: 'Other', value: 'Other' },
    ],
  },
  {
    id: 'youtubeChannel',
    question: 'Which YouTube channel led you to Botpress?',
    fieldName: 'youtubeChannel',
    required: true,
    options: [
      { label: 'Official Botpress Channel', value: 'Official Botpress Channel' },
      { label: 'Other', value: 'Other' },
    ],
  },
]
